import React, { useState } from 'react';
import { SlidersIcon, ChevronDownIcon } from 'lucide-react';
type FilterBarProps = {
  onFilterChange: (filters: any) => void;
  currentFilters: {
    price: string;
    category: string;
    rating: string;
    sort: string;
  };
};
export const FilterBar = ({
  onFilterChange,
  currentFilters
}: FilterBarProps) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const handleChange = (key: string, value: string) => {
    onFilterChange({
      ...currentFilters,
      [key]: value
    });
  };
  const FilterSelect = ({
    label,
    value,
    onChange,
    options
  }: any) => <div className="w-full" data-id="element-60">
      <label className="block text-sm text-gray-500 mb-1 md:hidden" data-id="element-61">
        {label}
      </label>
      <select value={value} onChange={e => onChange(e.target.value)} className="w-full text-sm border border-gray-200 rounded-md px-3 py-1.5" data-id="element-62">
        <option value="" data-id="element-63">{label}</option>
        {options.map((option: any) => <option key={option.value} value={option.value} data-id="element-64">
            {option.label}
          </option>)}
      </select>
    </div>;
  return <div className="bg-white border-b border-gray-200" data-id="element-65">
      <div className="px-4 py-4 sm:px-6 lg:px-8" data-id="element-66">
        {/* Mobile View */}
        <div className="md:hidden" data-id="element-67">
          <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="w-full flex items-center justify-between px-4 py-2 bg-gray-50 rounded-lg" data-id="element-68">
            <div className="flex items-center" data-id="element-69">
              <SlidersIcon className="h-4 w-4 text-gray-500 mr-2" data-id="element-70" />
              <span className="text-sm font-medium text-gray-700" data-id="element-71">Filters</span>
            </div>
            <ChevronDownIcon className={`h-4 w-4 text-gray-500 transform transition-transform ${showMobileFilters ? 'rotate-180' : ''}`} data-id="element-72" />
          </button>
          {showMobileFilters && <div className="mt-4 space-y-4" data-id="element-73">
              <FilterSelect label="Price" value={currentFilters.price} onChange={(value: string) => handleChange('price', value)} options={[{
            value: 'free',
            label: 'Free'
          }, {
            value: 'paid',
            label: 'Paid'
          }]} data-id="element-74" />
              <FilterSelect label="Category" value={currentFilters.category} onChange={(value: string) => handleChange('category', value)} options={[{
            value: 'productivity',
            label: 'Productivity'
          }, {
            value: 'creativity',
            label: 'Creativity'
          }, {
            value: 'development',
            label: 'Development'
          }, {
            value: 'education',
            label: 'Education'
          }, {
            value: 'entertainment',
            label: 'Entertainment'
          }]} data-id="element-75" />
              <FilterSelect label="Rating" value={currentFilters.rating} onChange={(value: string) => handleChange('rating', value)} options={[{
            value: '4plus',
            label: '4.0 & up'
          }, {
            value: '3plus',
            label: '3.0 & up'
          }, {
            value: '2plus',
            label: '2.0 & up'
          }]} data-id="element-76" />
              <FilterSelect label="Sort by" value={currentFilters.sort} onChange={(value: string) => handleChange('sort', value)} options={[{
            value: 'popular',
            label: 'Most Popular'
          }, {
            value: 'newest',
            label: 'Newest'
          }, {
            value: 'rating',
            label: 'Highest Rated'
          }]} data-id="element-77" />
            </div>}
        </div>
        {/* Desktop View */}
        <div className="hidden md:flex items-center space-x-4" data-id="element-78">
          <div className="flex items-center" data-id="element-79">
            <SlidersIcon className="h-4 w-4 text-gray-500 mr-2" data-id="element-80" />
            <span className="text-sm font-medium text-gray-700" data-id="element-81">Filters:</span>
          </div>
          <select value={currentFilters.price} onChange={e => handleChange('price', e.target.value)} className="text-sm border border-gray-200 rounded-md px-3 py-1.5" data-id="element-82">
            <option value="" data-id="element-83">Price</option>
            <option value="free" data-id="element-84">Free</option>
            <option value="paid" data-id="element-85">Paid</option>
          </select>
          <select value={currentFilters.category} onChange={e => handleChange('category', e.target.value)} className="text-sm border border-gray-200 rounded-md px-3 py-1.5" data-id="element-86">
            <option value="" data-id="element-87">Category</option>
            <option value="productivity" data-id="element-88">Productivity</option>
            <option value="creativity" data-id="element-89">Creativity</option>
            <option value="development" data-id="element-90">Development</option>
            <option value="education" data-id="element-91">Education</option>
            <option value="entertainment" data-id="element-92">Entertainment</option>
          </select>
          <select value={currentFilters.rating} onChange={e => handleChange('rating', e.target.value)} className="text-sm border border-gray-200 rounded-md px-3 py-1.5" data-id="element-93">
            <option value="" data-id="element-94">Rating</option>
            <option value="4plus" data-id="element-95">4.0 & up</option>
            <option value="3plus" data-id="element-96">3.0 & up</option>
            <option value="2plus" data-id="element-97">2.0 & up</option>
          </select>
          <div className="flex-1" data-id="element-98" />
          <div className="flex items-center space-x-2 text-sm text-gray-700" data-id="element-99">
            <span data-id="element-100">Sort by:</span>
            <select value={currentFilters.sort} onChange={e => handleChange('sort', e.target.value)} className="border border-gray-200 rounded-md px-3 py-1.5" data-id="element-101">
              <option value="popular" data-id="element-102">Most Popular</option>
              <option value="newest" data-id="element-103">Newest</option>
              <option value="rating" data-id="element-104">Highest Rated</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
};